import { datalabHttp } from '@dbl/services/common';
import { AxiosRequestConfig } from 'axios';
import { IFilterGroupsResponse, IFilterValuesResponse } from './type';

// 获取用户筛选器列表
export function getUserFilterGroups(params: {
  game_code: string;
  table_ids: string[];
}): Promise<IFilterGroupsResponse> {
  const options: AxiosRequestConfig = {
    url: '/api/v1/datalab/get_user_filter_groups',
    method: 'post',
    data: params,
  };
  return datalabHttp(options) as Promise<IFilterGroupsResponse>;
}

// 获取筛选器的属性值列表
export function getUserFilterValues(params: {
  game_code: string;
  filter_id: string;
}): Promise<IFilterValuesResponse> {
  const options: AxiosRequestConfig = {
    url: '/api/v1/datalab/get_user_filter_values',
    method: 'post',
    data: params,
  };
  return datalabHttp(options) as Promise<IFilterValuesResponse>;
}

